import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Layout from "components/Layout";
// Add your imports here
import Homepage from "pages/homepage";

import ServicesDeepDive from "pages/services-deep-dive";
import AboutEcosystem from "pages/about-ecosystem";
import ContactConsultation from "pages/contact-consultation";
import PrivacyPolicy from "pages/privacy-policy";
import TermsOfService from "pages/terms-of-service";
import CookiePolicy from "pages/cookie-policy";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<Layout><Homepage /></Layout>} />
        <Route path="/homepage" element={<Layout><Homepage /></Layout>} />

        <Route path="/services-deep-dive" element={<Layout><ServicesDeepDive /></Layout>} />
        <Route path="/about-ecosystem" element={<Layout><AboutEcosystem /></Layout>} />
        <Route path="/contact-consultation" element={<Layout><ContactConsultation /></Layout>} />
        <Route path="/privacy-policy" element={<Layout><PrivacyPolicy /></Layout>} />
        <Route path="/terms-of-service" element={<Layout><TermsOfService /></Layout>} />
        <Route path="/cookie-policy" element={<Layout><CookiePolicy /></Layout>} />
        <Route path="*" element={<Layout><NotFound /></Layout>} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;